export interface S3UploadTicket {
  data: {};
  url: string;
}

export interface S3TranscodeUploadTicket {
  id: string;
  upload: {
    url: string;
    fields: {
      key: string;
      policy: string;
      'x-amz-algorithm': string;
      'x-amz-credential': string;
      'x-amz-date': string;
      'x-amz-signature': string;
    };
  };
}

export enum TranscodeStatus {
  NOT_STARTED = 'not_started',
  RUNNING = 'running',
  DONE = 'done',
  ERROR = 'error',
}

export enum TranscodeSpec {
  RecordingTranscodeSpec = 'session_recording',
  WidgetTranscodeSpec = 'widget',
  WidgetNoAudioTranscodeSpec = 'widget_no_audio',
}

export interface TranscodeProcess {
  id: string;
  sourceId: string;
  transcodeStatus: TranscodeStatus;
}
